<template>
  <div class="">
    <edit-deferred-cash-entries> </edit-deferred-cash-entries>
  </div>
</template>

<script>
import EditDeferredCashEntries from "@/components/accounting/cash-entries/deferred/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "removeBreadcrumbs" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditDeferredCashEntries,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Sospeso",
        path: "movimenti_prima_nota.edit1",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Sospeso",
        path: "movimenti_prima_nota.edit1",
        level: 4,
      });
    }
  },
};
</script>
